<template>
  <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition">
    <template v-slot:activator="{ on }">
      <v-tooltip v-on="on" top>
        <template v-slot:activator="{ on }">
          <v-btn class="mx-2" color="accent" v-on="on" @click="dialog = true">
            <v-icon dark>mdi-arrow-down-bold-hexagon-outline</v-icon>
          </v-btn>
        </template>
        <span>Add Inventory</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Add Inventory</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click="UpdateShopInventory()">Update Shop</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-text-field v-model="Search" label="Filter by Name" outlined class="py-3 px-6"></v-text-field>
      <v-row>
        <v-col cols="12" md="6" v-for="i in 2" :key="'lable'+i" class="px-2 py-0">
          <v-row>
            <v-col cols="2">
              <v-card-subtitle class="py-0 ma-0 secondary--text">Name</v-card-subtitle>
            </v-col>
            <v-col cols="2">
              <v-card-subtitle class="py-0 secondary--text">Type</v-card-subtitle>
            </v-col>
            <v-col cols="3">
              <v-card-subtitle class="py-0 secondary--text">Description</v-card-subtitle>
            </v-col>
            <v-col cols="1">
              <v-card-subtitle class="py-0 secondary--text">Qty</v-card-subtitle>
            </v-col>
            <v-col cols="2">
              <v-card-subtitle class="py-0 secondary--text">Price</v-card-subtitle>
            </v-col>
            <v-col cols="2">
              <v-card-subtitle class="pa-0 ma-0 secondary--text">Included?</v-card-subtitle>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          md="6"
          v-for="(item, index) in filteredItems"
          :key="index"
          class="px-2 py-0"
        >
          <v-row>
            <v-col cols="2">
              <v-card-subtitle class="py-0 ma-0">
                <a class="py-0 ma-0" :href="item.Url" target="_blank">
                  <span class="blue--text" v-if="item.Url">{{ item.Name }}</span>
                  <span v-if="!item.Url">{{ item.Name }}</span>
                </a>
              </v-card-subtitle>
            </v-col>
            <v-col cols="2">
              <v-card-subtitle class="py-0">{{ item.Type }}</v-card-subtitle>
            </v-col>
            <v-col cols="3">
              <v-card-subtitle class="py-0">
                {{
                item.Description
                }}
              </v-card-subtitle>
            </v-col>
            <v-col cols="1">
              <v-card-subtitle class="py-0">{{ item.Qty }}</v-card-subtitle>
            </v-col>
            <v-col cols="2">
              <v-card-subtitle class="py-0">{{ item.Price }}</v-card-subtitle>
            </v-col>
            <v-col cols="2">
              <v-checkbox v-model="selected" :value="item" class="py-0 ma-0"></v-checkbox>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import db from "@/fb";
import { store } from "@/fb";
import firebase from "firebase/app";
import "firebase/auth";

export default {
  name: "InvSelect",
  props: ["Shopid"],
  data: () => ({
    types: ["Weapon", "Armor", "Consumable", "Mis"],
    newItem: {},
    dialog: false,
    Search: "",
    campaign: { MasterInventory: [] },
    tempIndex: null,
    tempItem: {},
    showedit: false,
    selected: [],
  }),
  components: {},
  methods: {
    UpdateShopInventory() {
      this.selected.forEach((e) => {
        this.shop.Inventory.push(e);
      });
      db.collection("shops")
        .doc(this.Shopid)
        .update({ Inventory: this.shop.Inventory });
      this.dialog = false;
      this.selected = [];
    },
  },
  computed: {
    filteredItems: function () {
      return this.campaign.MasterInventory.filter((item) => {
        if (typeof item.Name === "undefined") {
          item.Name = "";
        }
        return item.Name.toLowerCase().match(this.Search.toLowerCase());
      });
    },
  },

  firestore() {
    this.$bind(
      "campaign",
      db.collection("campaigns").doc(store.CurrentCampaign.id)
    );
    this.$bind("shop", db.collection("shops").doc(this.Shopid));
  },
  created() {
    firebase.auth().onAuthStateChanged((cred) => {
      this.playerid = cred.uid;
    });
  },
};
</script>
